import React from 'react'
import Alert from 'react-bootstrap/Alert'
import { Icon } from '../icon'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons'
import { useActions, useMessage } from '../../store'

/** an Alert that displays the 'message' value from the store */
const SuccessAlert = () => {
  const message = useMessage()
  const { setMessage } = useActions()

  return message ? (
    <Alert variant='success' dismissible onClose={() => setMessage('')}>
      <Icon icon={faThumbsUp} size='lg' />
      {message}
    </Alert>
  ) : null
}

export { SuccessAlert }
